import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div>
      <hr style={{ width: "80%", marginLeft: "auto", marginRight: "auto" }} />
      <div class="container awards">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <span
              style={{
                color: "#d06615",
              }}
              className="fw-bolder"
            >
              App Store Editor's Choice
            </span>
            <br />
            <span className="fw-light">Apple App Store</span>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <button className="btn btn-dark buttonstyle">
              <i
                class="fa-brands fa-apple fa-2x"
                style={{ marginRight: "4px" }}
              ></i>
              <span style={{ fontSize: "1.2rem", marginLeft: "0px" }}>
                Download
              </span>
              <br></br>
              <span style={{ fontSize: "0.8rem", padding: "17px" }}>
                on the App store{" "}
              </span>
            </button>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-12">
            <span
              style={{ color: "#d06615"}}
              className="fw-bolder"
            >
              App Of The Year Runner-Up
            </span>
            <br />
            <span className="fw-light">App Store Rewind - 2011</span>
          </div>
        </div>
      </div>
      <hr style={{ width: "80%", marginLeft: "auto", marginRight: "auto" }} />
      <div class="container d-flex justify-content-around">
        <div class="row policy">
          <div class="col-lg-2 col-md-6 col-sm-12 fw-lighter">About</div>
          <div class="col-lg-2 col-md-6 col-sm-12 fw-lighter">Newsletter</div>
          <div class="col-lg-2 col-md-6 col-sm-12 fw-lighter">Support</div>
          <div class="col-lg-2 col-md-6 col-sm-12 fw-lighter">Templates</div>
          <div class="col-lg-2 col-md-6 col-sm-12 fw-lighter">Privacy</div>
          <div class="col-lg-2 col-md-6 col-sm-12 fw-lighter">Terms</div>
        </div>
      </div>

      {/* <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12 column1">
            
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 column1">
            <button className="connect">
              <span>
                <i c<button className="connect">
              <span>
                <i className="fa-brands fa-twitter fs-"></i>
              </span>
              Twitter
            </button>lassName="fa-sharp fa-solid fa-thumbs-up fs-6"></i>
              </span>
              Follow
            </button>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 column1">
            <button className="connect">
              <span>
                <i className="fa-sharp fa-solid fa-square-share-nodes fs-6"></i>
              </span>
              &nbsp;share
            </button>
          </div>
        </div>
      </div> */}
      <div className="container">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <button
            className="connect"
            style={{
              height: "40px",
              width: "110px",
              borderRadius: "200px",
              fontSize: "10px",
              marginRight: "10px",
              // padding: "0 10px 0 10px",
            }}
          >
            <span>
              <i
                className="fa-brands fa-twitter fa-2xl"
                style={{ marginRight: "5px" }}
              ></i>
            </span>
            Twitter
          </button>
          <button
            className="connect"
            style={{
              height: "40px",
              width: "110px",
              borderRadius: "200px",
              fontSize: "10px",
              marginRight: "10px",
              // padding: "0 10px 0 10px",
            }}
          >
            <span>
              <i
                class="fa-brands fa-facebook-f fa-2xl"
                style={{ marginRight: "5px" }}
              ></i>
            </span>
            Facebook
          </button>
          <button
            className="connect"
            style={{
              height: "40px",
              width: "110px",
              borderRadius: "200px",
              fontSize: "10px",
              marginRight: "10px",
              // padding: "0 10px 0 10px",
            }}
          >
            <span>
              <i
                class="fa-solid fa-share-nodes fa-2xl"
                style={{ marginRight: "5px" }}
              ></i>
            </span>
            Share
          </button>
        </div>
      </div>
      <div className="container social-media">
        <span>
          <i class="fa-brands fa-twitter links"></i>
        </span>
        <span>
          <i class="fa-brands fa-facebook"></i>
        </span>
        <span>
          <i class="fa-brands fa-instagram"></i>
        </span>
      </div>
      <div className="copyright">
        <p>
          Copyright © 2009 - 2022 d3i Ltd. All Rights Reserved.
          <br />
          Momento is a registered trademark of d3i Ltd.
        </p>
      </div>
    </div>
  );
};

export default Footer;
